import React from "react";

const SideNav = () => {
  return (
    <>

      <nav className="sidenav">
        <ul>
          <li>
            <a href="#home-top">
              Top
            </a>
          </li>
          <li>
            <a href="#home-services">Services</a>
          </li>
          <li>
            <a href="#insights">Insights</a>
          </li>
          <li>
            <a href="#service-areas">Service Areas</a>
          </li>
          <li>
            <a href="#inside-icoess">Inside ICOESS</a>
          </li>
          <li>
            <a href="#home-contact-section">Contact Us</a>
          </li>
          
        </ul>
      </nav>
    </>
  );
};

export default SideNav;
